import React from 'react';
import { Card } from './ui/Card';
import { Users, TrendingUp, Calendar, Database } from 'lucide-react';
const stats = [{
  icon: Users,
  value: '1.200+',
  label: 'Vertriebsprofis betreut',
  color: 'text-blue-500'
}, {
  icon: TrendingUp,
  value: '€7M+',
  label: 'Zusätzlicher Umsatz',
  color: 'text-green-500'
}, {
  icon: Calendar,
  value: '4,5',
  label: 'Jahre CRM-Fokus',
  color: 'text-orange-500'
}, {
  icon: Database,
  value: '110+',
  label: 'CRM-Systeme',
  color: 'text-purple-500'
}];
export function StatsBar() {
  return <section className="py-12 bg-[#0A0E27]" data-id="element-242">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-243">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-244">
          {stats.map((stat, index) => <Card key={index} className="p-6 flex items-center space-x-4 hover:border-[#334155] transition-colors" data-id="element-245">
              <div className={`p-3 rounded-lg bg-[#1E293B] ${stat.color}`} data-id="element-246">
                <stat.icon className="w-6 h-6" data-id="element-247" />
              </div>
              <div data-id="element-248">
                <div className="text-2xl font-bold text-white" data-id="element-249">
                  {stat.value}
                </div>
                <div className="text-sm text-[#94A3B8]" data-id="element-250">{stat.label}</div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}